<h1>
    Contratistas
    <span class="badge accent">{{ pageContratistas?.totalElements }}</span>
</h1>

<div class="message-box info">
    Contratistas disponibles para el grupo de servicio
    <strong>{{ grupo?.descripcion }}</strong> en la comuna de
    <strong *ngIf="!cambiarComuna">{{ comuna?.nombre }}</strong>
    <div *ngIf="cambiarComuna">
        <mat-form-field class="full-width">
            <mat-label>Comunas</mat-label>
            <mat-select
                required
                (selectionChange)="buscarContratristas($event)"
            >
                <mat-option
                    *ngFor="let comunaRegion of comunasRegion"
                    [value]="comunaRegion.id"
                >
                    {{ comunaRegion.nombre }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div fxFlex fxLayout="column" fxFlexAlign="end end" class="mt-8">
            <button mat-button (click)="cambiarComuna = false" color="accent">
                Cancelar
            </button>
        </div>
    </div>
    <button
        *ngIf="!cambiarComuna"
        mat-icon-button
        size="small"
        title="Cambiar de comuna"
        color="accent"
        (click)="cambiarComuna = true"
    >
        <mat-icon>pin_drop</mat-icon>
    </button>
</div>

<div fxLayout="row" fxLayoutAlign="space-around center">
    <mat-spinner
        *ngIf="cargandoContratistas"
        color="accent"
        diameter="50"
    ></mat-spinner>
</div>
<div *ngIf="pageContratistas">
    <div
        *ngIf="pageContratistas.empty && !cargandoContratistas"
        class="mt-8 message-box error"
    >
        No se han encontrado contratistas
    </div>

    <mat-selection-list
        #contratistasSelect
        style="height: 250px; overflow-y: scroll"
    >
        <mat-list-option
            [value]="contratista"
            checkboxPosition="after"
            *ngFor="let contratista of pageContratistas.content"
        >
            <!-- img
                matListAvatar
                matListItemLeft
                class="avatar-imagen-mini"
                [src]="getFoto(contratista.codigoFoto)"
            
                [alt]="contratista.nombres + ' ' + contratista.apellidos"
                (click)="verFichaContratista($event, contratista.nrRut)"
            / -->

            <h3
                matLine
                class="accent-fg"
                (click)="verFichaContratista($event, contratista.nrRut)"
            >
                {{ contratista.nombres }}
                {{ contratista.apellidos }}
            </h3>
            <p
                matLine
                class="accent-fg"
                (click)="verFichaContratista($event, contratista.nrRut)"
            >
                <small>{{ contratista.rut }}</small>
            </p>
            <p matLine>
                <app-star-rating
                    [seteable]="false"
                    [cantidadEstrellas]="config.rating.cantidadEstrellas"
                    [evaluacion]="contratista.evaluacion"
                ></app-star-rating>
            </p>
        </mat-list-option>
    </mat-selection-list>

    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <button
                mat-icon-button
                color="accent"
                (click)="anterior()"
                *ngIf="!pageContratistas.first"
            >
                <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
        </div>
        <div *ngIf="pageContratistas.totalPages > 1">
            {{ pagina + 1 }} / {{ pageContratistas.totalPages }}
        </div>
        <div>
            <button
                mat-icon-button
                color="accent"
                (click)="siguiente()"
                *ngIf="!pageContratistas.last"
            >
                <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
        </div>
    </div>
    <p *ngIf="!pageContratistas.empty && puedeAsignar">
        Contratistas seleccionados:
        {{ contratistasSelect.selectedOptions?.selected?.length }}
    </p>

    <mat-divider></mat-divider>
    <div class="mt-8 mb-8" fxLayout="row" fxLayoutAlign="end end">
        <button
            mat-raised-button
            color="accent"
            [disabled]="
                contratistasSelect.selectedOptions.selected.length === 0
            "
            (click)="invitar(contratistasSelect.selectedOptions.selected)"
        >
            Invitar a cotizar
        </button>
    </div>
</div>
